import { itemGroupStatusBadgeClass, itemGroupStatusLabel, packStatusBadgeClass, packStatusLabel } from "./packStatus.util.js";

export function PackStatusBadge({ status }) {
  return (
    <span className={`badge ${packStatusBadgeClass(status)}`}>
      {packStatusLabel(status)}
    </span>
  );
}

export function ItemGroupStatusBadge({ status }) {
  return (
    <span className={`badge ${itemGroupStatusBadgeClass(status)}`}>
      {itemGroupStatusLabel(status)}
    </span>
  );
}
